import { Image } from "antd"
import { observer } from "mobx-react"
import React from "react"
import ExpertPC from "../../assets/Header/ExpertPC.svg"
import LogoPC from "../../assets/Header/Pru_Logo.svg"
import LogoMob from "../../assets/Header/Pru_Mob.svg"
import AppStore from "../../Configs/Store/index"
import ModalStore from "../../Configs/Store/modals"
import { DataLayerFn } from "../../Configs/API"
import CalculatorStore from "../../Configs/Store/calculator"
import "./Header.less"

const HeaderModule = observer(({ type }) => {
  const handlemodalOpen = () => {
    ModalStore.setTalk2Expert(true)
    try {
      DataLayerFn(`TalkToExpert_Selected`, CalculatorStore, "Consult an expert")
    } catch {}
  }

  const homePage = () => {
    window.location = "https://www.iciciprulife.com/"
  }

  return (
    <div className="headerMain">
      <div className="headerParent">
        <div className="headerChild">
          <Image preview={false} className="headerImage1" srcSet={AppStore.device === 0 ? LogoMob : LogoPC} onClick={homePage} />
        </div>
        <div className="headerSideItems">
          <div className="headerExpert" onClick={handlemodalOpen}>
            <img src={ExpertPC} alt={"Talk To Expert"} className="headerExpert_Image" />
            {AppStore.device === 1 && <div className="headerExpert_Text"> Talk to an Expert </div>}
          </div>
        </div>
      </div>
    </div>
  )
})

export default HeaderModule
